<script>
  import isEmpty from 'lodash/isEmpty';

  import DpFileIconCSV from './DpFileIcon/DpFileIconCSV.vue'
  import DpFileIconDOC from './DpFileIcon/DpFileIconDOC.vue'
  import DpFileIconDOCX from './DpFileIcon/DpFileIconDOCX.vue'
  import DpFileIconJPG from './DpFileIcon/DpFileIconJPG.vue'
  import DpFileIconPDF from './DpFileIcon/DpFileIconPDF.vue'
  import DpFileIconPNG from './DpFileIcon/DpFileIconPNG.vue'
  import DpFileIconPPT from './DpFileIcon/DpFileIconPPT.vue'
  import DpFileIconPPTX from './DpFileIcon/DpFileIconPPTX.vue'
  import DpFileIconSVG from './DpFileIcon/DpFileIconSVG.vue'
  import DpFileIconTIFF from './DpFileIcon/DpFileIconTIFF.vue'
  import DpFileIconTXT from './DpFileIcon/DpFileIconTXT.vue'
  import DpFileIconXLS from './DpFileIcon/DpFileIconXLS.vue'
  import DpFileIconXLSX from './DpFileIcon/DpFileIconXLSX.vue'
  import DpFileIconXML from './DpFileIcon/DpFileIconXML.vue'

  export default {
    name: "DpFileIcon",
    props: {
      fileExtension: {type: String, required: true},
      width: {type: String},
      height: {type: String},
      inverted: {type: Boolean, default: false},
      outlined: {type: Boolean, default: false}
    },
    components: {
      DpFileIconCSV,
      DpFileIconDOC,
      DpFileIconDOCX,
      DpFileIconJPG,
      DpFileIconPDF,
      DpFileIconPNG,
      DpFileIconPPT,
      DpFileIconPPTX,
      DpFileIconSVG,
      DpFileIconTIFF,
      DpFileIconTXT,
      DpFileIconXLS,
      DpFileIconXLSX,
      DpFileIconXML
    },
    computed: {
      style() {
        if (isEmpty(this.width) && isEmpty(this.height))
          return undefined;
        return {
          width: (isEmpty(this.width)) ? 'auto' : this.width,
          height: (isEmpty(this.height)) ? 'auto' : this.height,
        }
      },
      viewBox() {
        return this.outlined ? '0 0 63.75 73' : '0 0 61.75 69';
      },
      defaultWidth() {
        return this.outlined ? '63.75' : '61.75';
      },
      defaultHeight() {
        return this.outlined ? '73' : '69';
      }
    }
  }
</script>

<template>
    <svg class="dp-file-icon"
         xmlns="http://www.w3.org/2000/svg"
         :style="style"
         :width="defaultWidth"
         :height="defaultHeight"
         :viewBox="viewBox">
      <DpFileIconCSV v-if="fileExtension === 'csv'" :outlined="outlined" :inverted="inverted"/>
      <DpFileIconDOC v-if="fileExtension === 'doc'" :outlined="outlined" :inverted="inverted"/>
      <DpFileIconDOCX v-if="fileExtension === 'docx'" :outlined="outlined" :inverted="inverted"/>
      <DpFileIconJPG v-if="fileExtension === 'jpg'" :outlined="outlined" :inverted="inverted"/>
      <DpFileIconPDF v-if="fileExtension === 'pdf'" :outlined="outlined" :inverted="inverted"/>
      <DpFileIconPNG v-if="fileExtension === 'png'" :outlined="outlined" :inverted="inverted"/>
      <DpFileIconPPT v-if="fileExtension === 'ppt'" :outlined="outlined" :inverted="inverted"/>
      <DpFileIconPPTX v-if="fileExtension === 'pptx'" :outlined="outlined" :inverted="inverted"/>
      <DpFileIconSVG v-if="fileExtension === 'svg'" :outlined="outlined" :inverted="inverted"/>
      <DpFileIconTIFF v-if="fileExtension === 'tiff'" :outlined="outlined" :inverted="inverted"/>
      <DpFileIconTXT v-if="fileExtension === 'txt'" :outlined="outlined" :inverted="inverted"/>
      <DpFileIconXLS v-if="fileExtension === 'xls'" :outlined="outlined" :inverted="inverted"/>
      <DpFileIconXLSX v-if="fileExtension === 'xlsx'" :outlined="outlined" :inverted="inverted"/>
      <DpFileIconXML v-if="fileExtension === 'xml'" :outlined="outlined" :inverted="inverted"/>
    </svg>
</template>
